var map = {
	"./26.jpg": 55646,
	"./36.jpg": 34285,
	"./43.jpg": 83871,
	"./AdmissionDesk.jpg": 92601,
	"./Infrastructure.jpeg": 65132,
	"./LifeSkillCurricullum.jpg": 80993,
	"./MessageLeaders.jpg": 62548,
	"./ParentsStudentsVoice.jpg": 68726,
	"./PedagogyCovere.jpg": 33485,
	"./PoemRecitation2.jpg": 55154,
	"./chess.jpg": 29622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95138;